import React from 'react';
import { Box } from '@mui/material';

const IntelSwiftDefaultLogo = React.forwardRef((props, ref) => {
	const { sx, ...other } = props;
	const width = props.width || '28px';
	const height = props.height || '28px';
	return (
		<Box
			ref={ref}
			component="svg"
			width={width}
			height={height}
			viewBox="0 0 28 28"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			sx={{
				display: 'inline-block',
				...sx,
			}}
			{...other}
		>
			<path d="M26.7695 19.6778C25.5363 17.9054 23.4944 16.7468 21.184 16.7468C17.4185 16.7468 9.49905 23.6208 9.49905 23.6208C9.49905 23.6208 9.50758 23.6282 9.52422 23.6426L9.49905 23.6426C9.49905 23.6426 8.11038 24.848 6.57031 25.8499C8.72379 27.2133 11.2711 28.0016 14.0009 28.0016C19.6833 28.0016 24.575 24.5857 26.7695 19.6778Z" fill="url(#paint0_linear_1699_34435)" />
			<path d="M26.7731 19.6765C27.5327 17.9778 27.9691 16.1003 28.0033 14.1238C27.9103 10.409 24.8944 7.42645 21.1876 7.42645C17.4221 7.42645 9.50265 14.3005 9.50265 14.3005C9.50265 14.3005 9.51118 14.3079 9.52782 14.3222L9.50265 14.3222C9.50265 14.3222 5.43689 17.8516 3.50376 17.8516C1.72063 17.8516 0.248903 16.5071 0.03125 14.7687C0.321326 19.4419 2.86282 23.4992 6.57391 25.8486C8.11398 24.8467 9.50265 23.6412 9.50265 23.6412L9.52782 23.6412C9.51118 23.6269 9.50265 23.6195 9.50265 23.6195C9.50265 23.6195 17.4221 16.7454 21.1876 16.7454C23.498 16.7454 25.54 17.9041 26.7731 19.6765Z" fill="url(#paint1_linear_1699_34435)" />
			<path d="M9.49914 13.8584C9.49914 13.8584 17.4186 6.98431 21.1841 6.98431C24.9495 6.98431 28.002 10.0619 28.002 13.8584C28.002 13.8656 28.002 13.8729 28.002 13.8801H28.002C28.002 13.9644 28.0013 14.0486 27.9998 14.1326C27.9072 10.4175 24.8911 7.43451 21.1841 7.43451C17.4186 7.43451 9.49914 14.3086 9.49914 14.3086C9.49914 14.3086 9.50767 14.316 9.5243 14.3303L9.49914 14.3303C9.49914 14.3303 5.43338 17.8596 3.50025 17.8596C1.71711 17.8596 0.245394 16.5152 0.0277432 14.7768C0.00933984 14.4803 0 14.1813 0 13.8801C0 15.8293 1.56712 17.4094 3.50025 17.4094C5.43338 17.4094 9.49914 13.8801 9.49914 13.8801L9.5243 13.8801C9.50767 13.8658 9.49914 13.8584 9.49914 13.8584Z" fill="url(#paint2_linear_1699_34435)" />
			<path d="M1.38676 8.32374C2.6199 10.0962 4.66189 11.2548 6.97229 11.2548C10.7377 11.2548 18.6572 4.38075 18.6572 4.38075C18.6572 4.38075 18.6487 4.37335 18.632 4.35903L18.6572 4.35903C18.6572 4.35903 20.0459 3.15358 21.5859 2.15166C19.4325 0.788318 16.8851 -4.22863e-06 14.1553 -4.469e-06C8.47297 -4.96936e-06 3.58124 3.41588 1.38676 8.32374Z" fill="url(#paint3_linear_1699_34435)" />
			<path d="M9.49789 13.8682C9.49789 13.8682 5.43267 17.4022 3.49979 17.4022C1.56691 17.4022 0 15.82 0 13.8682C0 11.9164 1.56691 10.3342 3.49979 10.3342C5.43267 10.3342 9.49789 13.8682 9.49789 13.8682Z" fill="url(#paint4_linear_1699_34435)" />
			<defs>
				<linearGradient id="paint0_linear_1699_34435" x1="29.8344" y1="15.9364" x2="6.07778" y2="20.6776" gradientUnits="userSpaceOnUse">
					<stop stopColor="white" stopOpacity="0" />
					<stop offset="1" stopColor="white" />
				</linearGradient>
				<linearGradient id="paint1_linear_1699_34435" x1="-6.61149" y1="24.0386" x2="28.5143" y2="21.9286" gradientUnits="userSpaceOnUse">
					<stop stopColor="white" stopOpacity="0" />
					<stop offset="1" stopColor="white" />
				</linearGradient>
				<linearGradient id="paint2_linear_1699_34435" x1="-0.268175" y1="17.6201" x2="29.154" y2="1.82832" gradientUnits="userSpaceOnUse">
					<stop stopColor="white" stopOpacity="0" />
					<stop offset="1" stopColor="white" />
				</linearGradient>
				<linearGradient id="paint3_linear_1699_34435" x1="2.71646" y1="8.33982" x2="19.7366" y2="0.0966893" gradientUnits="userSpaceOnUse">
					<stop stopColor="white" stopOpacity="0" />
					<stop offset="1" stopColor="white" />
				</linearGradient>
				<linearGradient id="paint4_linear_1699_34435" x1="17.3755" y1="14.4759" x2="0.998653" y2="10.1166" gradientUnits="userSpaceOnUse">
					<stop stopColor="white" stopOpacity="0" />
					<stop offset="0.915" stopColor="white" />
				</linearGradient>
			</defs>
		</Box>
	);
});

IntelSwiftDefaultLogo.displayName = 'IntelSwiftDefaultLogo';

export default IntelSwiftDefaultLogo;
